import { useState, useEffect } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const teamService = {
  _url: process.env.REACT_APP_WORKSPACE_API_URL,

  GetInvitedMembers(searchQuery, fetch, workspaceId) {
    const [invitedMembers, setInvitedMembers] = useState({
      invitedMembers: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {

      if (!workspaceId) {
        setStatus(STATUS.SUCCESS);
        return;
      }
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getInvitedMembers(searchQuery))
        .then(res => {
          setInvitedMembers(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), fetch, workspaceId]);
    return {
      invitedMembers_loading: status === STATUS.LOADING,
      invitedMembers_error: status === STATUS.ERROR,
      invitedMembers_data: invitedMembers?.data,
    };
  },

  GetAllMembers(searchQuery, fetch, workspaceId) {
    const [allMembers, setAllMembers] = useState({
      allMembers: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
    
      if (!workspaceId) {
        setStatus(STATUS.SUCCESS);
        return;
      }
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getAllMembers(searchQuery))
        .then(res => {
          setAllMembers(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), fetch, workspaceId]);
    return {
      allMembers_loading: status === STATUS.LOADING,
      allMembers_error: status === STATUS.ERROR,
      allMembers_data: allMembers?.data,
    };
  },

  async getCurrentUserWorkspace() {
    let res = await Fetch.get(`${this._url}/get-all-workspaces`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async addMember(payload, workspaceId) {
    let res = await Fetch.post(`${this._url}/invite-member/${workspaceId}`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async checkUserAvailability(payload, workspaceId) {
    let res = await Fetch.post(`${this._url}/check-availability/${workspaceId}`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getInvitedMembers({
    page = 1,
    itemsPerPage = 10,
    searchText = '',
    getAll = false,
    startDate = '',
    endDate = '',
    workspaceId,
  }) {
    let res = await Fetch.get(
      `${this._url}/invited-members/${workspaceId}?page=${page}&itemsPerPage=${itemsPerPage}&searchText=${searchText}`,
    );
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something Went Wrong');
  },

  async getAllMembers({
    page = 1,
    itemsPerPage = 10,
    searchText = '',
    getAll = false,
    startDate = '',
    endDate = '',
    workspaceId,
  }) {
    let res = await Fetch.get(
      `${this._url}/all-members/${workspaceId}?page=${page}&itemsPerPage=${itemsPerPage}&searchText=${searchText}`,
    );
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something Went Wrong');
  },

  async verifyWorkspaceInvite(token) {
    let res = await Fetch.get(`${this._url}/verify-invite?token=${encodeURIComponent(token)}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Invalid or expired invitation');
  },

  async acceptWorkspaceInvite(payload) {
    let res = await Fetch.post(`${this._url}/accept-invite`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Failed to accept invitation');
  },
};

export default teamService;
